import React from 'react'

const BusinessUser = React.lazy(() => import('pages/BusinessUser/BusinessUser'));

const BusinessUserRoutes = [
    {
        path: '/business-user',
        exact: true,
        name: 'Phân nhân viên - Cơ sở',
        function: 'SYS_BUSINESS_USER_VIEW',
        component: BusinessUser,
    },
]

export default BusinessUserRoutes
